export const JiraAlignLogoInverse = () => (
  <svg
    width="213"
    height="48"
    viewBox="0 0 213 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.254 8.52734H56.395V29.5523C56.395 35.1193 53.956 38.9383 48.252 38.9383C46.09 38.9383 44.434 38.5703 43.283 38.1563V34.1533C44.525 34.6603 46.043 34.9353 47.56 34.9353C51.058 34.9353 52.253 32.8193 52.253 29.8293V8.52734H52.254Z"
      fill="white"
    />
    <path
      d="M63.891 6.91846C65.502 6.91846 66.651 7.93046 66.651 9.67846C66.651 11.4265 65.503 12.4395 63.891 12.4395C62.279 12.4395 61.131 11.4265 61.131 9.67846C61.131 7.93046 62.281 6.91846 63.891 6.91846ZM61.868 15.7515H65.825V38.7535H61.868V15.7515Z"
      fill="white"
    />
    <path
      d="M75.758 38.7531H71.895V15.7511H75.758V19.7991C77.092 17.0851 79.393 15.1531 83.903 15.4291V19.2931C78.842 18.7871 75.758 20.3051 75.758 25.1821V38.7531Z"
      fill="white"
    />
    <path
      d="M102.439 34.612C100.966 37.649 98.207 39.213 94.664 39.213C88.545 39.213 85.463 34.015 85.463 27.252C85.463 20.765 88.684 15.29 95.125 15.29C98.482 15.29 101.059 16.809 102.439 19.799V15.751H106.396V38.753H102.439V34.612ZM95.722 35.533C99.265 35.533 102.439 33.278 102.439 28.172V26.332C102.439 21.226 99.541 18.971 96.181 18.971C91.72 18.971 89.419 21.915 89.419 27.252C89.419 32.773 91.626 35.533 95.722 35.533Z"
      fill="white"
    />
    <path
      d="M121.16 31.9443L118.629 38.7533H113.983L125.899 8.52734H131.143L143.059 38.7533H138.413L135.882 31.8993C133.167 32.4513 130.821 32.7273 128.384 32.7273C126.083 32.7273 123.738 32.4513 121.161 31.9453L121.16 31.9443ZM134.639 28.4483L128.52 11.8863L122.401 28.4943C124.657 28.8623 126.542 29.0463 128.383 29.0463C130.315 29.0463 132.293 28.8173 134.639 28.4483Z"
      fill="white"
    />
    <path
      d="M151.98 38.8922C148.207 38.8922 145.814 37.0972 145.814 32.8652V6.13623H149.771V32.4052C149.771 34.4752 151.152 35.2122 152.853 35.2122C153.267 35.2122 153.542 35.2122 154.003 35.1662V38.7082C153.681 38.8002 152.991 38.8932 151.98 38.8932V38.8922Z"
      fill="white"
    />
    <path
      d="M159.844 6.91846C161.455 6.91846 162.604 7.93046 162.604 9.67846C162.604 11.4265 161.456 12.4395 159.844 12.4395C158.232 12.4395 157.084 11.4265 157.084 9.67846C157.084 7.93046 158.234 6.91846 159.844 6.91846ZM157.821 15.7515H161.778V38.7535H157.821V15.7515Z"
      fill="white"
    />
    <path
      d="M183.26 34.612C181.787 37.649 179.028 39.213 175.485 39.213C169.413 39.213 166.376 34.015 166.376 27.252C166.376 20.765 169.55 15.29 175.946 15.29C179.303 15.29 181.88 16.809 183.26 19.799V15.751H187.123V36.683C187.123 43.446 183.949 48 175.715 48C171.85 48 169.735 47.494 167.526 46.758V42.894C170.057 43.722 172.678 44.274 175.532 44.274C181.282 44.274 183.261 41.192 183.261 36.914V34.613L183.26 34.612ZM176.543 35.533C180.084 35.533 183.26 33.278 183.26 28.172V26.332C183.26 21.226 180.362 18.971 177.002 18.971C172.539 18.971 170.24 21.915 170.24 27.252C170.24 32.773 172.447 35.533 176.543 35.533Z"
      fill="white"
    />
    <path
      d="M212.654 38.753H208.697V24.859C208.697 20.718 207.041 18.879 203.267 18.879C199.587 18.879 197.058 21.317 197.058 25.964V38.753H193.101V15.751H197.058V19.523C198.529 16.808 201.244 15.29 204.326 15.29C209.617 15.29 212.654 18.925 212.654 25.273V38.752V38.753Z"
      fill="white"
    />
    <path
      d="M0 10.1895C0 15.5725 4.383 19.9365 9.761 19.9365H18.802V29.0065H28.563V11.7325C28.563 10.8805 27.873 10.1895 27.022 10.1895H0Z"
      fill="url(#paint0_linear_818_493)"
    />
    <path
      d="M28.564 38.7535C28.564 33.3705 24.181 29.0065 18.803 29.0065H9.761V19.9365H0V37.2105C0 38.0625 0.69 38.7535 1.541 38.7535H28.564Z"
      fill="url(#paint1_linear_818_493)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_493"
        x1="11.974"
        y1="31.4725"
        x2="14.194"
        y2="20.0505"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.15" stopColor="white" stopOpacity="0.4" />
        <stop offset="0.287" stopColor="white" stopOpacity="0.472" />
        <stop offset="0.564" stopColor="white" stopOpacity="0.661" />
        <stop offset="0.952" stopColor="white" stopOpacity="0.961" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_818_493"
        x1="16.59"
        y1="17.4695"
        x2="14.37"
        y2="28.8925"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.15" stopColor="white" stopOpacity="0.4" />
        <stop offset="0.287" stopColor="white" stopOpacity="0.472" />
        <stop offset="0.564" stopColor="white" stopOpacity="0.661" />
        <stop offset="0.952" stopColor="white" stopOpacity="0.961" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
